import { render, staticRenderFns } from "./sellersReport.vue?vue&type=template&id=4ad457b2&"
import script from "./sellersReport.vue?vue&type=script&lang=js&"
export * from "./sellersReport.vue?vue&type=script&lang=js&"
import style0 from "./sellersReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports